import { COLLECTION_FEE_RATE } from '@/config/fees'

/**
 * Calculate collection fee for a payment
 *
 * Fee structure: Flat 8% of all collected payments
 * (Simplified from previous tiered structure as of 2026-11-01)
 *
 * @param amount - Payment amount
 * @returns Collection fee (8% of amount)
 */
export function calculateCollectionFee(amount: number): number {
  return Number((amount * COLLECTION_FEE_RATE).toFixed(2))
}
